import { FC } from 'react';
import PrismAPI from '@modules/prism-client/types/prism-types';
import { htmlToReactNode } from '@modules/prism-client/lib/html-to-react-node';

type Props = {
  data: PrismAPI.Html | string | undefined;
};

export const Html: FC<Props> = ({ data }) => {
  return htmlToReactNode(data);
};
